import moment from 'moment'
import store from '..'
import * as types from '../mutation-types'

const EXPENSE_DETAIL_TYPE = 3

export default {
	namespaced: true,
	state: {
		expenses: [],
		stockId: null,
		isPosted: false
	},

	actions: {
		// العهدة الفعلية الحالية: آخر سجل غير مُرحَّل، وليس بالضرورة سجل اليوم.
		// يرجع السجل مع حركاته فلا حاجة لطلب ثانٍ، و 404 تعني لا عهدة مفتوحة أصلاً
		fetchCurrentStock() {
			return window.axios.get('/employeeStock/LastEmployeeStock', { preventHandling: true })
				.then(({ data }) => ({
					stock: data || null,
					expenses: ((data && data.custodyDetails) || [])
						.filter(detail => detail.custodyDetailsType === EXPENSE_DETAIL_TYPE)
				}))
				.catch(error => {
					if (error.response && error.response.status === 404) return { stock: null, expenses: [] }
					return Promise.reject(error)
				})
		},

		// عهدة يوم سابق: البحث في الحركات يرجّع مصاريف ذلك اليوم ومعها سجل العهدة التابعة له
		fetchStockByDate(context, { date }) {
			return window.axios.get('/employeeStock/details/search', {
				params: {
					employeeIds: [store.state.auth.self.employeeId],
					fromDate: date,
					toDate: date,
					custodyDetailTypes: [EXPENSE_DETAIL_TYPE]
				},
				// the endpoint expects repeated keys (collectionFormat: multi); axios' default
				// `ids[]=` form is not bound by the API and the filter is silently ignored
				paramsSerializer: { indexes: null }
			}).then(({ data }) => {
				const expenses = data.details || []
				return { stock: expenses.length ? expenses[0].stock : null, expenses }
			})
		},

		fetchExpenses({ commit, dispatch }, { date }) {
			const isToday = date === moment().format('YYYY-MM-DD')
			const stockRequest = isToday ? dispatch('fetchCurrentStock') : dispatch('fetchStockByDate', { date })

			return stockRequest.then(({ stock, expenses }) => {
				commit(types.STORE_EMPLOYEE_STOCK_EXPENSES, {
					expenses,
					stockId: stock ? stock.id : null,
					isPosted: Boolean(stock && stock.isPosted)
				})
			})
		},

		addExpense({ dispatch, state }, { date, name, amount }) {
			return window.axios.post(`/employeeStock/${state.stockId}/details`, {
				name,
				amount,
				custodyDetailsType: EXPENSE_DETAIL_TYPE
			}).then(() => dispatch('fetchExpenses', { date }))
		},

		updateExpense({ dispatch }, { date, id, name, amount }) {
			return window.axios.put(`/employeeStock/details/${id}`, {
				name,
				amount,
				custodyDetailsType: EXPENSE_DETAIL_TYPE
			}).then(() => dispatch('fetchExpenses', { date }))
		},

		deleteExpense({ dispatch }, { date, id }) {
			return window.axios.delete(`/employeeStock/details/${id}`)
				.then(() => dispatch('fetchExpenses', { date }))
		},

		reset({ commit }) {
			commit(types.RESET_EMPLOYEE_STOCK)
		}
	},

	mutations: {
		[types.STORE_EMPLOYEE_STOCK_EXPENSES](state, { expenses, stockId, isPosted }) {
			state.expenses = expenses
			state.stockId = stockId
			state.isPosted = isPosted
		},

		[types.RESET_EMPLOYEE_STOCK](state) {
			state.expenses = []
			state.stockId = null
			state.isPosted = false
		}
	},

	getters: {
		getExpenseEntries: state => state.expenses
	}
}
